/*
 * File: Home.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 9:53 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Constants
import { mediumBreakpoint, tabBarBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: block;
	padding: 20px 0px 50px 0px;
	margin: 0 auto;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		padding: 80px 0px 50px 0px;
	}
`;

export const Header = styled.div`
	display: flex;
	align-items: start;
	flex-direction: column;
	gap: 20px;

	h1 {
		flex-grow: 1;
	}
	@media only screen and (min-width: ${mediumBreakpoint}em) {
		flex-direction: row;
		align-items: center;
	}
`;

export const PanelContainer = styled.div`
	display: flex;
	width: 100%;
	padding: 30px 0px 0px;
	gap: 24px;

	.communityPanel {
		display: none !important;

		@media only screen and (min-width: ${tabBarBreakpoint}em) {
			display: block !important;
		}
	}
`;

export const ComponentPanel = styled.div`
	flex-grow: 1;
`;

export const ContentSwitcher = styled.div`
	position: relative;
	background-color: ${({ theme }) => theme.neutralButton};
	padding: 6px;
	border-radius: 29px;
	height: 50px;
	display: inline-flex;
	position: relative;
	align-items: center;
	width: 100%;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		width: auto;
	}
`;

export const SwitcherTab = styled.button`
	border: none;
	background-color: transparent;
	height: 100%;
	border-radius: 20px;
	padding: 0px 15px;
	cursor: pointer;
	flex-grow: 1;

	span {
		font-size: 14px;
	}
	${({ $isActive }) => $isActive && css`
		background-color: ${({ theme }) => theme.primaryButton};
		color: ${({ theme }) => theme.primaryBackground};
	`}
`;
